//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = value => (value ? value : "N/A");

export default {
  name: "WarehouseTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table
  },
  mounted: function() {
    this.columns = [
      {
        name: "id",
        required: false,
        align: "left",
        label: "ID - Ficheiro Carregamento",
        field: row => row.id,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "code",
        required: false,
        label: "Código",
        align: "left",
        field: row => row.code,
        format: DEFAULT_FORMAT,
        sortable: false
      },
      {
        name: "description",
        required: false,
        align: "left",
        label: "Descrição",
        field: row => row.name,
        format: DEFAULT_FORMAT,
        sortable: false
      }
    ];
  },
  data: () => ({
    separator: "horizontal",
    columns: [],
    filteredData: []
  }),
  methods: {
    renderRightSide: function(event) {
      this.$emit("clicked-row", JSON.parse(JSON.stringify(event)));
    },
    updateFilter: function(event) {
      this.$emit("filter-changed", event);
    }
  }
};
